/**
 * Company Data
 */

declare var Chart : any;
declare var ChartDataLabels : any;
declare var ChartjsPluginStacked100 : any;
declare var Odometer : any;
declare var ScrollMagic : any;

const company = () => {
  Chart.register(ChartjsPluginStacked100);
  var barPC = 89;
  var barSP = 64;

  /* stacked horizontal bar chart */
  function barChart(element : any) {
    const getLabels = element.getAttribute('data-labels');
    var labels = [];
    labels = getLabels?.split(',');

    const getValues = element.getAttribute('data-values');
    var values = [];
    values = getValues?.split(',');

    var chartLabel = element.getAttribute('data-chart')?.split(',');

    const data = {
      labels: chartLabel,
      datasets: [
        {
          label: labels[0],
          data: [values[0]],
          backgroundColor: '#34383E',
          borderSkipped: 'end',
          borderRadius: {
            topLeft: 4,
            topRight: 0,
            bottomRight: 0,
            bottomLeft: 4,
          },
          barThickness: (screen.width > 767) ? barPC : barSP,
        },
        {
          label: labels[1],
          data: [values[1]],
          backgroundColor: '#F39800',
          borderSkipped: 'start',
          borderRadius: {
            topLeft: 0,
            topRight: 4,
            bottomRight: 4,
            bottomLeft: 0,
          },
          barThickness: (screen.width > 767) ? barPC : barSP,
        }
      ],
    };

    const fillGaps = {
      id: 'fillGaps',
      beforeDatasetDraw(ch : any, args : any) {
        if (args.index == 1 && ch.isDatasetVisible(args.index)) {
          args.meta.data.forEach(function (item : any) {
            const { width } = item.getProps(['width'], true);
            item.base = item.x - width + 5;
          });
        }
      }
    };

    const config = {
      type: 'bar',
      data: data,
      plugins: [ChartDataLabels, fillGaps, ChartjsPluginStacked100],
      options: {
        indexAxis: 'y',
        stacked100: {
          enabled: true,
        },
        plugins: {
          title: {
            display: false,
          },
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
          datalabels: {
            color: '#fff',
            labels: {
              title: {
                font: {
                  weight: '500',
                  family: 'Zen Kaku Gothic New',
                  size: 15,
                }
              },
            },
            formatter: function (value : any, context : any) {
              return context.chart.data.datasets[context.datasetIndex].label;
            }
          }
        },
        scales: {
          x: {
            display: false,
            stacked: true,
            grid: {
              display: false,
            }
          },
          y: {
            display: false,
            stacked: true,
            grid: {
              display: false,
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };

    const canvas = <HTMLCanvasElement> element;
    const ctx = canvas.getContext('2d');
    new Chart(ctx, config);
  }

  /* pie chart */
  function pieChart(element : any) {
    const getLabels = element.getAttribute('data-labels');
    var labels = [];
    labels = getLabels?.split(',');

    const getValues = element.getAttribute('data-values');
    var values = [];
    values = getValues?.split(',');

    const getBackground = element.getAttribute('data-bg');
    var bg = [];
    bg = getBackground?.split(',');

    const getColor = element.getAttribute('data-color');
    var clr = [];
    clr = getColor?.split(',');

    const data = {
      labels: labels,
      datasets: [
        {
          label: labels,
          data: values,
          backgroundColor: bg,
          color: clr,
        }
      ],
    };
  
    const config = {
      type: 'pie',
      data: data,
      options: {
        plugins: {
          title: {
            display: false,
          },
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };

    new Chart(element, config);
  }

  /* odometer */
  function startCount(element:any) {
    const counter = element.querySelector('[data-odometer]');    
    const value = counter?.getAttribute('data-odometer');

    const od = new Odometer({
      el: counter,
      value: 0,
      format: 'd'
    });

    od.update(value);
  }
  
  var pie = document.querySelectorAll('.js-company-pie');
  var bar = document.querySelectorAll('.js-company-bar');
  var odo = document.querySelectorAll('.js-odo');
  var lbl = document.querySelectorAll('.js-pie-label');

  /* chart animation */
  const trig = document.querySelector('.js-company-data');

  let controller = new ScrollMagic.Controller({ addIndicators: true });

  let scene = new ScrollMagic.Scene({
    triggerElement: trig,
  }).addTo(controller);

  scene.on('enter', function () {
    if (pie) {
      pie.forEach(element => {
        pieChart(element);
      });

      if (lbl) {        
        lbl.forEach(element=>{
          element.classList.add('animate');
        });
      }
    }

    if (bar) {
      bar.forEach(element => {
        barChart(element);      
      });
    }

    if (odo) {
      odo.forEach(element => {
        startCount(element);
      });
    }
  });

  scene.triggerHook(0.8);
};

export default company;
